export default __webpack_public_path__ + "static/case.studies-16b93bf1e0519700a5e8477ac2cc51ad.png";